/**
 * Returns a list of ingredient display names from a recipe-like object.
 * Priority: item.ingredient?.name -> item.name -> skip if falsy
 * Checks both 'ingredients' and 'recipeIngredient' properties
 */
export function getRecipeIngredientNames(recipe) {
    console.log('getRecipeIngredientNames called with:', recipe);
    if (!recipe)
        return [];
    const ingredientsList = recipe.ingredients || recipe.recipeIngredient;
    console.log('ingredientsList found:', ingredientsList);
    if (!Array.isArray(ingredientsList))
        return [];
    const mapped = ingredientsList.map((x) => {
        const name = x?.ingredient?.name ?? x?.name ?? null;
        console.log('Processing ingredient:', { item: x, extractedName: name });
        return name;
    });
    const filtered = mapped.filter((v) => typeof v === 'string' && v.trim().length > 0);
    console.log('Final filtered result:', filtered);
    return filtered;
}
/**
 * Returns a list of ingredient display names with translations from a recipe-like object.
 * Returns both English and translated names for specified language.
 */
export function getRecipeIngredientNamesWithTranslations(recipe, languageCode = 'zh-HK') {
    console.log('getRecipeIngredientNamesWithTranslations called with:', recipe, languageCode);
    if (!recipe)
        return { english: [], translated: [] };
    const ingredientsList = recipe.ingredients || recipe.recipeIngredient;
    console.log('ingredientsList found:', ingredientsList);
    if (!Array.isArray(ingredientsList))
        return { english: [], translated: [] };
    const english = [];
    const translated = [];
    ingredientsList.forEach((x) => {
        // Get English name (priority: ingredient.name -> name)
        const englishName = x?.ingredient?.name ?? x?.name ?? null;
        // Get translated name (priority: ingredient.name_translations -> name_translations)
        const translations = x?.ingredient?.name_translations ?? x?.name_translations ?? null;
        const translatedName = translations?.[languageCode] ?? null;
        console.log('Processing ingredient:', {
            item: x,
            englishName,
            translatedName,
            translations
        });
        if (englishName && typeof englishName === 'string' && englishName.trim().length > 0) {
            english.push(englishName);
            // Use translated name if available, otherwise fallback to English
            if (translatedName && typeof translatedName === 'string' && translatedName.trim().length > 0) {
                translated.push(translatedName);
            }
            else {
                translated.push(englishName); // Fallback to English if no translation
            }
        }
    });
    console.log('Final result:', { english, translated });
    return { english, translated };
}
